import { render, staticRenderFns } from "./article-builder-generic.vue?vue&type=template&id=184e89e9&scoped=true"
import script from "./article-builder-generic.vue?vue&type=script&lang=js"
export * from "./article-builder-generic.vue?vue&type=script&lang=js"
import style0 from "./article-builder-generic.vue?vue&type=style&index=0&id=184e89e9&prod&scoped=true&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "184e89e9",
  null
  
)

export default component.exports